import React from "react";

// SVGs
import {ReactComponent as e4} from "../assets/images/icons/new_sim(1).svg";
import {ReactComponent as e5} from "../assets/images/icons/transfer_sim (1).svg";
import {ReactComponent as Arrow} from "../assets/images/icons/arrow.svg";
import {ReactComponent as User} from "../assets/images/icons/user-icon.svg";
import {ReactComponent as ArrowUp} from "../assets/images/icons/arrow-up-black.svg";

import {ReactComponent as downloadSpeed} from "../assets/images/icons/fixed/downloadSpeed.svg";
import {ReactComponent as uploadSpeed} from "../assets/images/icons/fixed/uploadSpeed.svg";
import {ReactComponent as tvCharacteristics} from "../assets/images/icons/fixed/tvCharacteristics.svg";
import {ReactComponent as minutesToNational} from "../assets/images/icons/fixed/minutesToNational.svg";
import {ReactComponent as minutesToFixed} from "../assets/images/icons/fixed/minutesToFixed.svg";
import {ReactComponent as smsCharacteristics} from "../assets/images/icons/fixed/smsCharacteristics.svg";
import {ReactComponent as minutesToMobile} from "../assets/images/icons/fixed/minutesToMobile.svg";
import {ReactComponent as dataCharacteristics} from "../assets/images/icons/fixed/dataCharacteristics.svg";
import {ReactComponent as fixedSm} from "../assets/images/icons/fixed/fixedSm.svg";

import {ReactComponent as devicePlan} from "../assets/images/icons/device_discount (1).svg";
import {ReactComponent as noDevicePlan} from "../assets/images/icons/bill_discount (1).svg";
import {ReactComponent as b2b} from "../assets/images/icons/pig_bank (1).svg";

import {ReactComponent as infoIcon} from "../assets/images/icons/information-icon.svg";
import {ReactComponent as minIcon} from "../assets/images/icons/minus-green.svg";
import {ReactComponent as plusIcon} from "../assets/images/icons/plus-green.svg";
import {ReactComponent as arrowIcon} from "../assets/images/icons/arrow-right.svg";

import {ReactComponent as unlimited} from "../assets/images/icons/infinity-icon.svg";
import {ReactComponent as mobile} from "../assets/images/icons/fixed/mobile-placeholder.svg";

import {ReactComponent as info} from "../assets/images/icons/info.svg";
import {ReactComponent as checkMark} from "../assets/images/icons/thanks-page-check.svg";
import {ReactComponent as Placeholder} from "../assets/images/icons/placeholder.svg";

// PNGs
import Refresh from "../assets/images/icons/refresh.png";
import enFlag from "../assets/images/flags/en.png";
import grFlag from "../assets/images/flags/gr.png";
import logoGr from "../assets/images/logo_gr.png";
import logoEn from "../assets/images/logo_en.png";
import logoMob from "../assets/images/logo_mobile.png"
import Device_1 from "../assets/images/icons/pic_iPhone_14.png";
import filter from "../assets/images/icons/filter.png";
import mastercard from "../assets/images/master-cc.png";
import visacard from "../assets/images/visa-cc.png";
import versignSecure from "../assets/images/verisign-secured.png";
import Spinner from "../assets/images/Spinner.png";
import Small_spinner from "../assets/images/Small_spinner.png";

const Icon = ({name, width = "24", height = "24", ...props}) => {
    const Svgs = {
        arrow: Arrow,
        placeholder: Placeholder,
        user: User,
        minutesToFixed: minutesToFixed,
        smsCharacteristics: smsCharacteristics,
        minutesToMobile: minutesToMobile,
        dataCharacteristics: dataCharacteristics,
        checkMark: checkMark,
        fixedSm: fixedSm,
        infoSm: info,
        devicePlan: devicePlan,
        noDevicePlan: noDevicePlan,
        infoIcon: infoIcon,
        minIcon: minIcon,
        plusIcon: plusIcon,
        unlimited: unlimited,
        mobile: mobile,
        arrowIcon: arrowIcon,
        arrowUp: ArrowUp,
        e4: e4,
        e5: e5,
        b2b: b2b,
        minutesToNational: minutesToNational,
        tvCharacteristics: tvCharacteristics,
        downloadSpeed: downloadSpeed,
        uploadSpeed: uploadSpeed
    };

    const Pngs = {
        refresh: Refresh,
        grFlag: grFlag,
        enFlag: enFlag,
        logoEn: logoEn,
        logoGr: logoGr,
        logoMob: logoMob,
        device1: Device_1,
        filter: filter,
        mastercard: mastercard,
        visacard: visacard,
        versignSecure: versignSecure,
        Spinner: Spinner,
        Small_spinner: Small_spinner,
    };

    const SelectedSvg = Svgs[name];
    const SelectedPng = Pngs[name];

    if (SelectedSvg) {
        return <SelectedSvg width={width} height={height} {...props} />;
    }

    if (SelectedPng) {
        return (
            <img
                src={SelectedPng}
                width={width}
                height={height}
                alt={name}
                {...props}
            />
        );
    }

    return <Placeholder width={width} height={height} {...props} />; // No recognized icon name
};

export default Icon;
